import React from "react";
import { FieldArray, useFormikContext } from "formik";
import { Checkbox } from "primereact/checkbox";
import { Table } from "react-bootstrap";
import {
  FormArrayTextField,
  FormOutlinedNoMarginTextField,
} from "../../../../../partials/content/Forms/FormField";
import Illustration from "../../../../../partials/content/Illustration";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
import { InputAdornment } from "@material-ui/core";

function DiscountTriggerItems({
  setIndexSelected,
  setOpenSearchItemType,
  setOpenSearchItem,
  setArrayName,
  setItemSelected,
  setOpenSearchUom,
  displayOnly = false,
}) {
  const { values, setFieldValue } = useFormikContext();
  return (
    <div className="row">
      <div className="col-sm-12 col-md-12 col-lg-12">
        <FieldArray name="discountTriggerItem">
          {({ push, remove }) => (
            <React.Fragment>
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <div className="card">
                    <Table borderless size="sm" responsive="xl">
                      {values.discountTriggerItem &&
                      values.discountTriggerItem.length > 0 ? (
                        <thead className="text-center">
                          <tr>
                            <th style={{ width: "10%" }}>Combination</th>
                            <th style={{ width: "45%" }}>Item Name</th>
                            <th style={{ width: "20%" }}>Quantity</th>
                            <th style={{ width: "20%" }}>Unit</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                      ) : null}
                      <tbody>
                        {values.discountTriggerItem &&
                        values.discountTriggerItem.length > 0 ? (
                          values.discountTriggerItem.map((item, index) => {
                            return (
                              <React.Fragment key={index}>
                                <tr>
                                  <td
                                    style={{
                                      whiteSpace: "nowrap",
                                    }}
                                    className="text-center"
                                  >
                                    <div className="p-field-checkbox my-2">
                                      <Checkbox
                                        icon="pi pi-check-circle"
                                        inputId="binary"
                                        onChange={(e) => {
                                          setFieldValue(
                                            `discountTriggerItem[${index}].combineFlag`,
                                            e.checked
                                          );
                                        }}
                                        checked={item.combineFlag}
                                      />
                                    </div>
                                  </td>
                                  <td>
                                    <FormOutlinedNoMarginTextField
                                      value={`${item.itemCode} ${item.itemName}`}
                                      InputProps={{
                                        startAdornment:
                                          item.itemType > 0 ? (
                                            <InputAdornment position="start">
                                              <BootstrapTooltip
                                                title={item.itemTypeName}
                                              >
                                                <i
                                                  className={
                                                    item.itemType === 1
                                                      ? "fas fa-boxes text-success"
                                                      : item.itemType === 2
                                                      ? "fas fa-tools text-primary"
                                                      : item.itemType === 3
                                                      ? "fas fa-building text-info"
                                                      : item.itemType === 4
                                                      ? "fas fa-boxes text-warning"
                                                      : item.itemType === 5
                                                      ? "fas fa-boxes text-danger"
                                                      : null
                                                  }
                                                ></i>
                                              </BootstrapTooltip>
                                            </InputAdornment>
                                          ) : null,
                                        readOnly: true,
                                      }}
                                    />
                                  </td>
                                  <td>
                                    <FormArrayTextField
                                      index={index}
                                      arrayPropName="discountTriggerItem"
                                      propName="requireQty"
                                      quantityField
                                      margin="none"
                                    />
                                  </td>
                                  <td>
                                    <FormArrayTextField
                                      index={index}
                                      arrayPropName="discountTriggerItem"
                                      propName="uomName"
                                      margin="none"
                                      readonly
                                      searchButton
                                      onSearchClick={() => {
                                        setArrayName("discountTriggerItem");
                                        setIndexSelected(index);
                                        setItemSelected(item);
                                        setOpenSearchUom(true);
                                      }}
                                    />
                                  </td>
                                  <td
                                    style={{
                                      whiteSpace: "nowrap",
                                    }}
                                    className="text-center"
                                  >
                                    {!displayOnly ? (
                                      <BootstrapTooltip
                                        title={
                                          item.deleteInd
                                            ? "Undo Delete"
                                            : "Delete Discount Trigger Item"
                                        }
                                      >
                                        <button
                                          type="button"
                                          className={`btn btn-icon btn-label-${
                                            item.deleteInd
                                              ? "warning"
                                              : "danger"
                                          } btn-md btn-circle mx-1`}
                                          onClick={() => {
                                            if (item.ID > 0) {
                                              setFieldValue(
                                                "discountTriggerItem[" +
                                                  index +
                                                  "].deleteInd",
                                                !item.deleteInd
                                              );
                                            } else {
                                              remove(index);
                                            }
                                          }}
                                        >
                                          {item.deleteInd ? (
                                            <i className="fas fa-undo-alt"></i>
                                          ) : (
                                            <i className="fas fa-trash-alt"></i>
                                          )}
                                        </button>
                                      </BootstrapTooltip>
                                    ) : null}
                                  </td>
                                </tr>
                              </React.Fragment>
                            );
                          })
                        ) : (
                          <tr>
                            <td className="text-center py-3" colSpan="5">
                              <Illustration
                                imageSource="INVIFO Sales.png"
                                guidance="You don't have any Discount Trigger items yet"
                                guidanceLeftIcon="fas fa-info-circle kt-font-warning"
                                size="sm"
                              ></Illustration>
                            </td>
                          </tr>
                        )}
                        <tr>
                          <td className="text-center py-3" colSpan="5">
                            <button
                              type="button"
                              className="btn btn-label-primary btn-md btn-pill btn-bold mx-1"
                              onClick={() => {
                                setArrayName("discountTriggerItem");
                                setIndexSelected(0);
                                setOpenSearchItemType(true);
                              }}
                            >
                              <i className="fas fa-plus-circle"></i>
                              Add Trigger Item
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>
            </React.Fragment>
          )}
        </FieldArray>
      </div>
    </div>
  );
}

export default DiscountTriggerItems;
